import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ListItem } from 'material-ui';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

export class MenuItemLinkComponent extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  };

  handleMenuTap = () => {
    this.props.history.push(this.props.to);
    this.props.onClick();
  };
  render() {
    const {
      history,
      match,
      location,
      staticContext,
      ...props
    } = this.props;


    return (
      <React.Fragment>
        {this.props.to && <ListItem {...props} containerElement={Link} onClick={this.handleMenuTap} />}
        {this.props.href && <a style={{ textDecoration: 'none' }} href={this.props.href}> <ListItem {...props} /> </a>}
      </React.Fragment>
    );
  }
}

export default withRouter(MenuItemLinkComponent);
